// Product status codes match the investcore backend enums
// (model.ProductStatusType / model.StockStatus):
// 1001 Draft, 1002 Published, 1003 Coming Soon, 1004 Staging (stocks/ETFs only).
export const productStatusColors = {
  1001: 'yellow',
  1002: 'green',
  1003: 'orange',
  1004: 'purple',
};

export const productStatusLabels = {
  1001: 'Drafted',
  1002: 'Published',
  1003: 'Coming Soon',
  1004: 'Staging',
};

export const productStatusOptions = [
  { value: 1001, label: 'Drafted' },
  { value: 1002, label: 'Published' },
  { value: 1003, label: 'Coming Soon' },
];

// Staging is only defined for stocks/ETFs (StockStatusStaging = 1004):
// unlisted — hidden from list APIs but still served by detail APIs.
export const stockStatusOptions = [
  ...productStatusOptions,
  { value: 1004, label: 'Staging' },
];

export const productRiskLevelOptions = [
  { value: 1001, label: 'Low' },
  { value: 1002, label: 'Low Medium' },
  { value: 1003, label: 'Medium' },
  { value: 1004, label: 'Medium High' },
  { value: 1005, label: 'High' },
];
